exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-games-2048-tsx": () => import("./../../../src/pages/games/2048.tsx" /* webpackChunkName: "component---src-pages-games-2048-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-mint-tsx": () => import("./../../../src/pages/mint.tsx" /* webpackChunkName: "component---src-pages-mint-tsx" */)
}

